import importSaga from "./import"
import reportsSaga from "./reports"

export default [...importSaga, ...reportsSaga]
